"use strict";
// (C) 2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormatsLabel = exports.getAttachmentType = exports.getRecipientsLabel = void 0;
var tslib_1 = require("tslib");
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var compact_1 = tslib_1.__importDefault(require("lodash/compact"));
exports.getRecipientsLabel = function (intl, recipients, currentUserEmail) {
    var numberOfRecipients = recipients.length;
    return numberOfRecipients === 1 && recipients[0] === currentUserEmail
        ? intl.formatMessage({ id: "dialogs.schedule.management.recipients.onlyYou" })
        : intl.formatMessage({
            id: "dialogs.schedule.management.recipients",
        }, { n: numberOfRecipients });
};
exports.getAttachmentType = function (intl, attachments) {
    var hasDashboardAttachment = attachments.some(sdk_model_1.isDashboardAttachment);
    var numberOfWidgetAttachments = attachments.filter(sdk_model_1.isWidgetAttachment).length;
    if (hasDashboardAttachment && numberOfWidgetAttachments) {
        return {
            AttachmentIcon: sdk_ui_kit_1.Icon.Many,
            attachmentLabel: intl.formatMessage({ id: "dialogs.schedule.management.attachments.mixed" }, { n: numberOfWidgetAttachments }),
        };
    }
    else if (numberOfWidgetAttachments) {
        return {
            AttachmentIcon: sdk_ui_kit_1.Icon.Insight,
            attachmentLabel: intl.formatMessage({ id: "dialogs.schedule.management.attachments.widgets" }, { n: numberOfWidgetAttachments }),
        };
    }
    else {
        return {
            AttachmentIcon: sdk_ui_kit_1.Icon.Dashboard,
            attachmentLabel: intl.formatMessage({ id: "dialogs.schedule.management.attachments.dashboard" }),
        };
    }
};
exports.getFormatsLabel = function (attachments) {
    var hasPdfFormat = attachments.some(sdk_model_1.isDashboardAttachment);
    var widgetAttachments = attachments.filter(sdk_model_1.isWidgetAttachment);
    var hasCsvFormat = widgetAttachments.some(function (attachment) { return attachment.formats.includes("csv"); });
    var hasXlsxFormat = widgetAttachments.some(function (attachment) { return attachment.formats.includes("xlsx"); });
    return compact_1.default([hasPdfFormat && "PDF", hasCsvFormat && "CSV", hasXlsxFormat && "XLSX"]).join(", ");
};
//# sourceMappingURL=utils.js.map